import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Reasons from './Reasons';
import Description from './Description';
import Product from '../Product';

import { Button, ButtonWithLoader, ButtonGroup, Dialog, DialogActions, DialogContent, DialogTitle, InputLabel } from '../../../../../Styles';

import { updateSuccessMessage, updateErrorMessage } from '../../../../../../actions/commonActions';

const GetHelp = ({ products, ...props }) => {
	const [open, setOpen] = useState(false);
	const [submitting, setSubmitting] = useState(false);
	const [errors, setErrors] = useState({});
	const [reason, setReason] = useState('');
	const [description, setDescription] = useState('');

	const updateError = (errors) => {
		setErrors((prevErrors) => ({
			...prevErrors,
			...errors,
		}));
	};

	const checkErrors = () => {
		return Object.keys(errors).some((key) => errors[key]);
	};

	const handleSubmit = async () => {
		let { updateErrorMessage, updateSuccessMessage } = props;

		if (checkErrors()) {
			updateErrorMessage(true, 'Clear errors before saving.');
			return;
		}

		setSubmitting(true);
		setSubmitting(false);

		if (false) {
			// updateSuccessMessage(true, `Item ${performingItemUpdate ? 'updated' : 'added'} successfully. Item Id: ${product?.supplier_product_id}`);
			setOpen(false);
		}
	};

	useEffect(() => {}, [open]);

	return (
		<>
			<Button
				outline
				primary
				disabled={!products?.length}
				onClick={(e) => {
					setOpen(true);
				}}
			>
				Get Help
			</Button>

			<Dialog
				fullWidth
				open={open}
				onClose={(e) => setOpen(false)}
			>
				<DialogTitle>Please select an issue or tell us about your issue</DialogTitle>

				<DialogContent padding={'1rem'}>
					<Reasons
						value={reason}
						error={errors?.reason}
						onChange={(value) => {
							setReason(value);
						}}
						onError={(error) => {
							updateError({ reason: error });
						}}
					/>

					<Description
						required={true}
						value={description}
						error={errors?.description}
						onChange={(value) => {
							setDescription(value);
						}}
						onError={(error) => {
							updateError({ description: error });
						}}
					/>

					<InputLabel>Attachments:</InputLabel>
					{products.map((product) => (
						<Product
							details={product}
							disabled={true}
						/>
					))}
				</DialogContent>

				<DialogActions>
					<ButtonGroup alignRight>
						<Button
							outline
							onClick={(e) => {
								setOpen(false);
							}}
						>
							Cancel
						</Button>

						<ButtonWithLoader
							loading={submitting}
              disabled={true}
							onClick={(e) => {
								handleSubmit();
							}}
						>
							Save
						</ButtonWithLoader>
					</ButtonGroup>
				</DialogActions>
			</Dialog>
		</>
	);
};

const mapStateToProps = (state) => {
	return {};
};

const mapDispatch = { updateSuccessMessage, updateErrorMessage };

export default withRouter(connect(mapStateToProps, mapDispatch)(GetHelp));
